import axios from "axios";
import { Message, MessageBox } from "element-ui";
import { UserModule } from "@/store/modules/user";
import { openLoading, closeLoading } from "@/utils/loading";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000
});

declare module "axios" {
  export interface AxiosRequestConfig {
    isLoading?: boolean;
  }
}

let needLoadingRequestCount = 0; // 声明一个对象用于存储请求个数
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    openLoading();
  }
  needLoadingRequestCount++;
}
function hideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    closeLoading();
  }
}

// Request interceptors
service.interceptors.request.use(
  config => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    if (UserModule.userInfo.token) {
      config.headers.Authorization = "Bearer " + UserModule.userInfo.token;
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
      //console.log(config.headers.Authorization);
    }
    if (config.isLoading === true) {
      // 默认不加载 如果配置了isLoading: true，则显示loading
      showFullScreenLoading();
    }
    return config;
  },
  error => {
    hideFullScreenLoading();
    console.log(error);
    Promise.reject(error);
  }
);

// Response interceptors
service.interceptors.response.use(
  async response => {
    // Some example codes here:
    // code == 20000: success
    // code == 50001: invalid access token
    // code == 50002: already login in other place
    // code == 50003: access token expired
    // code == 50004: invalid user (user not exist)
    // code == 50005: username or password is incorrect
    // You can change this part for your own usage.
    hideFullScreenLoading(); // 响应成功关闭loading
    const res = response.data;
    //console.log(res);
    //console.log(response);
    if (res.status !== 1) {
      if (res.status === 401) {
        await UserModule.RefreshToen().then(() => {
          if (UserModule.userInfo.refreshToken === "") {
            // MessageBox.confirm(
            //   "你已被登出，可以取消继续留在该页面，或者重新登录",
            //   "确定登出",
            //   {
            //     confirmButtonText: "重新登录",
            //     cancelButtonText: "取消",
            //     type: "warning"
            //   }
            // ).then(() => {
            //   UserModule.ResetToken();
            //   location.reload(); // To prevent bugs from vue-router
            // });
            UserModule.ResetToken();
            location.reload(); // To prevent bugs from vue-router

            return Promise.reject(new Error(res.msg || "Error"));
          }
        });

        response.config.headers.Authorization =
          "Bearer " + UserModule.userInfo.token;
        return service(response.config);
      } else if (res.status === 400) {
        UserModule.SetIdentityAuth(false);
      }
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 5 * 1000
      });
      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      return response.data;
    }
  },
  error => {
    hideFullScreenLoading();
    console.log(error);
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });

    return Promise.reject(error);
  }
);

export default service;
